import { registerRoutingKey } from "Common/routingUtils";
export default {
    ABOUT: registerRoutingKey("ABOUT")
};
